"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6511,6738],{

/***/ 36511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "asyncStandardizeCart": function() { return /* binding */ asyncStandardizeCart; },
/* harmony export */   "getCart": function() { return /* binding */ getCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48080);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);
/* harmony import */ var _types_BigCommerce_BCCart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6888);
/* harmony import */ var _helpers_isShippingProtection__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10304);
/* harmony import */ var _services_FramedCheckout_cartServices_worryFreeDeliverySession__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16033);
/* harmony import */ var _helpers_isFeatureEnabled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(965);
/* harmony import */ var _withWorryFreeQuote__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24332);
/* harmony import */ var _rawAddWarranty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16738);














var formCartStandardizer = function(param) {
    var generateLineItemsFromBCCart = param.generateLineItemsFromBCCart, getCustomItems = param.getCustomItems, standardizeCart = param.standardizeCart;
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(bcCart) {
            var ref, lineItems, customItems, standardizedCart;
            return _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return generateLineItemsFromBCCart(bcCart);
                    case 3:
                        lineItems = _ctx.sent;
                        customItems = getCustomItems({
                            lineItems: lineItems,
                            customItems: bcCart === null || bcCart === void 0 ? void 0 : (ref = bcCart.lineItems) === null || ref === void 0 ? void 0 : ref.customItems
                        });
                        standardizedCart = standardizeCart((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, bcCart), {
                            email: bcCart.email || "",
                            lineItems: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(lineItems).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(customItems))
                        }));
                        return _ctx.abrupt("return", standardizedCart);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(bcCart) {
            return _ref.apply(this, arguments);
        };
    }();
};
var removeWFD = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cart) {
        var ref, rawCartDeleteItem, shippingProtections, i;
        return _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 7012).then(__webpack_require__.bind(__webpack_require__, 87012))
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    rawCartDeleteItem = ref[0].rawCartDeleteItem;
                    shippingProtections = cart.lineItems.filter(_helpers_isShippingProtection__WEBPACK_IMPORTED_MODULE_12__/* .isShippingProtection */ .R);
                    i = 0;
                case 8:
                    if (!(i < shippingProtections.length)) {
                        _ctx.next = 14;
                        break;
                    }
                    _ctx.next = 11;
                    return rawCartDeleteItem({
                        cartId: cart.id,
                        itemId: shippingProtections[i].id
                    });
                case 11:
                    i += 1;
                    _ctx.next = 8;
                    break;
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function removeWFD(cart) {
        return _ref.apply(this, arguments);
    };
}();
var asyncStandardizeCart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(bcCart) {
        var ref, standardizeCart, generateLineItemsFromBCCart, getCustomItems, standardizer;
        return _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 9874).then(__webpack_require__.bind(__webpack_require__, 29874)),
                            Promise.all(/* import() */[__webpack_require__.e(1724), __webpack_require__.e(7690), __webpack_require__.e(8531), __webpack_require__.e(7971), __webpack_require__.e(7565)]).then(__webpack_require__.bind(__webpack_require__, 30917)),
                            __webpack_require__.e(/* import() */ 9342).then(__webpack_require__.bind(__webpack_require__, 9342)), 
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 3);
                    standardizeCart = ref[0].standardizeCart;
                    generateLineItemsFromBCCart = ref[1].generateLineItemsFromBCCart;
                    getCustomItems = ref[2].getCustomItems;
                    standardizer = formCartStandardizer({
                        generateLineItemsFromBCCart: generateLineItemsFromBCCart,
                        getCustomItems: getCustomItems,
                        standardizeCart: standardizeCart
                    });
                    return _ctx.abrupt("return", standardizer(bcCart));
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function asyncStandardizeCart(bcCart) {
        return _ref.apply(this, arguments);
    };
}();
var getCart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(providedRawCart) {
        var ref, ref1, ref2, ref3, standardizeCart, generateLineItemsFromBCCart, getCustomItems, rawGetCart, validProvidedRawCart, rawCart, initialCart, shippingProtections, WFDQuote, refreshedCart, cartWithWorryFreeQuote, customerOptedOut, applyByDefault, quoteChanged, itemsChanged, shouldApplyNewWFDQuote, newCart;
        return _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .fF)("getCart START");
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z;
                    _ctx.next = 5;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 9874).then(__webpack_require__.bind(__webpack_require__, 29874)),
                            Promise.all(/* import() */[__webpack_require__.e(1724), __webpack_require__.e(7690), __webpack_require__.e(8531), __webpack_require__.e(7971), __webpack_require__.e(7565)]).then(__webpack_require__.bind(__webpack_require__, 30917)),
                            __webpack_require__.e(/* import() */ 9342).then(__webpack_require__.bind(__webpack_require__, 9342)),
                            __webpack_require__.e(/* import() */ 9134).then(__webpack_require__.bind(__webpack_require__, 49217)), 
                        ];
                    });
                case 5:
                    _ctx.t1 = _ctx.sent;
                    ref3 = (0, _ctx.t0)(_ctx.t1, 4);
                    standardizeCart = ref3[0].standardizeCart;
                    generateLineItemsFromBCCart = ref3[1].generateLineItemsFromBCCart;
                    getCustomItems = ref3[2].getCustomItems;
                    rawGetCart = ref3[3].rawGetCart;
                    validProvidedRawCart = null;
                    try {
                        if (providedRawCart) {
                            validProvidedRawCart = (0,_types_BigCommerce_BCCart__WEBPACK_IMPORTED_MODULE_3__/* .assertBCCart */ .st)(providedRawCart);
                        }
                    } catch (e) {
                        (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .log */ .cM)("Invalid providedRawCart", {
                            providedRawCart: providedRawCart,
                            error: e
                        });
                    }
                    _ctx.t2 = validProvidedRawCart;
                    if (_ctx.t2) {
                        _ctx.next = 18;
                        break;
                    }
                    _ctx.next = 17;
                    return rawGetCart();
                case 17:
                    _ctx.t2 = _ctx.sent;
                case 18:
                    rawCart = _ctx.t2;
                    if (rawCart) {
                        _ctx.next = 21;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 21:
                    _ctx.next = 23;
                    return formCartStandardizer({
                        generateLineItemsFromBCCart: generateLineItemsFromBCCart,
                        getCustomItems: getCustomItems,
                        standardizeCart: standardizeCart
                    })(rawCart);
                case 23:
                    initialCart = _ctx.sent;
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .log */ .cM)("initialCart", initialCart);
                    shippingProtections = initialCart.lineItems.filter(_helpers_isShippingProtection__WEBPACK_IMPORTED_MODULE_12__/* .isShippingProtection */ .R);
                    _ctx.next = 28;
                    return (0,_withWorryFreeQuote__WEBPACK_IMPORTED_MODULE_5__/* .withWorryFreeQuote */ .q)(initialCart);
                case 28:
                    WFDQuote = _ctx.sent;
                    if (WFDQuote.warrantyOfferId) {
                        _ctx.next = 39;
                        break;
                    }
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .log */ .cM)("No WFD Quote", {
                        initialCart: initialCart,
                        WFDQuote: WFDQuote,
                        shippingProtections: shippingProtections
                    });
                    if (!(shippingProtections.length > 0)) {
                        _ctx.next = 38;
                        break;
                    }
                    _ctx.next = 34;
                    return removeWFD(initialCart);
                case 34:
                    _ctx.next = 36;
                    return getCart();
                case 36:
                    refreshedCart = _ctx.sent;
                    return _ctx.abrupt("return", refreshedCart);
                case 38:
                    return _ctx.abrupt("return", initialCart);
                case 39:
                    if ((0,_helpers_isFeatureEnabled__WEBPACK_IMPORTED_MODULE_4__/* .isFeatureEnabled */ .cr)("worryFreeDelivery")) {
                        _ctx.next = 41;
                        break;
                    }
                    return _ctx.abrupt("return", initialCart);
                case 41:
                    cartWithWorryFreeQuote = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, initialCart), {
                        warrantyOfferId: WFDQuote === null || WFDQuote === void 0 ? void 0 : WFDQuote.warrantyOfferId,
                        warrantyOfferPrice: WFDQuote === null || WFDQuote === void 0 ? void 0 : WFDQuote.warrantyOfferPrice,
                        warrantyOfferItems: WFDQuote === null || WFDQuote === void 0 ? void 0 : WFDQuote.warrantyOfferItems
                    });
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .log */ .cM)("cartWithWorryFreeQuote", cartWithWorryFreeQuote);
                    customerOptedOut = (0,_services_FramedCheckout_cartServices_worryFreeDeliverySession__WEBPACK_IMPORTED_MODULE_13__/* .customerOptedOutOfWFD */ .rq)();
                    applyByDefault = !((ref = initialCart.warrantyOfferId) === null || ref === void 0 ? void 0 : ref.length) && !!((ref1 = cartWithWorryFreeQuote.warrantyOfferId) === null || ref1 === void 0 ? void 0 : ref1.length) && !customerOptedOut;
                    quoteChanged = initialCart.warrantyOfferPrice && WFDQuote && initialCart.warrantyOfferPrice !== cartWithWorryFreeQuote.warrantyOfferPrice;
                    itemsChanged = cartWithWorryFreeQuote && !((ref2 = initialCart.warrantyOfferId) === null || ref2 === void 0 ? void 0 : ref2.length) && shippingProtections.length > 0;
                    shouldApplyNewWFDQuote = applyByDefault || itemsChanged || quoteChanged;
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .log */ .cM)("shouldApplyNewWFDQuote", {
                        shouldApplyNewWFDQuote: shouldApplyNewWFDQuote,
                        applyByDefault: applyByDefault,
                        quoteChanged: quoteChanged,
                        itemsChanged: itemsChanged
                    });
                    if (!shouldApplyNewWFDQuote) {
                        _ctx.next = 59;
                        break;
                    }
                    _ctx.next = 52;
                    return removeWFD(initialCart);
                case 52:
                    if (!cartWithWorryFreeQuote.warrantyOfferId) {
                        _ctx.next = 55;
                        break;
                    }
                    _ctx.next = 55;
                    return (0,_rawAddWarranty__WEBPACK_IMPORTED_MODULE_6__.rawAddWarranty)(cartWithWorryFreeQuote);
                case 55:
                    _ctx.next = 57;
                    return getCart();
                case 57:
                    newCart = _ctx.sent;
                    return _ctx.abrupt("return", newCart);
                case 59:
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .fF)("getCart END", {
                        cart: cartWithWorryFreeQuote
                    });
                    return _ctx.abrupt("return", cartWithWorryFreeQuote);
                case 61:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCart(providedRawCart) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (getCart);


/***/ }),

/***/ 16738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Cart_rawAddWarranty; },
  "rawAddWarranty": function() { return /* binding */ rawAddWarranty; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./services/Log.ts
var Log = __webpack_require__(27429);
// EXTERNAL MODULE: ./data/constants/SHIPPED_SHIELD_SKU.ts
var SHIPPED_SHIELD_SKU = __webpack_require__(49125);
;// CONCATENATED MODULE: ./helpers/toShippingProtectionSKU.ts

var toShippingProtectionSKU = function(param) {
    var offerId = param.offerId, items = param.items;
    return "".concat(SHIPPED_SHIELD_SKU/* SHIPPED_SHIELD_SKU */.E, ";").concat(offerId, ";").concat(items.map(function(param) {
        var sku = param.sku, quantity = param.quantity, price = param.price;
        return "".concat(sku, "_").concat(quantity, "_").concat(price);
    }).join(","));
};

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./services/Configuration.js
var Configuration = __webpack_require__(16977);
;// CONCATENATED MODULE: ./services/Cart/rawCartAddCustomItem.ts





var rawCartAddCustomItem = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var cartId, items, quoteIds;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cartId = param.cartId, items = param.items, quoteIds = param.quoteIds;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return axios_default().post("".concat(Configuration.SHOP_ORIGIN, "/oauth/sf/cart/custom-item"), {
                        cartId: cartId,
                        quoteIds: quoteIds,
                        items: items
                    });
                case 4:
                    return _ctx.abrupt("return", {
                        success: true
                    });
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](1);
                    (0,Log/* error */.vU)("Failed to remove the item from the cart");
                case 10:
                    return _ctx.abrupt("return", {
                        success: false
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                7
            ]
        ]);
    }));
    return function rawCartAddCustomItem(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var Cart_rawCartAddCustomItem = ((/* unused pure expression or super */ null && (rawCartAddCustomItem)));

;// CONCATENATED MODULE: ./services/Cart/rawAddWarranty.ts





var rawAddWarranty = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cart) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (cart.warrantyOfferId) {
                        _ctx.next = 3;
                        break;
                    }
                    throw new Error("No warranty offer ID found");
                case 3:
                    _ctx.next = 5;
                    return rawCartAddCustomItem({
                        cartId: cart.id,
                        quoteIds: cart.warrantyOfferId.map(function(item) {
                            return item.quoteId;
                        }),
                        items: cart.warrantyOfferId.map(function(item) {
                            return {
                                name: "Worry Free Delivery-".concat(item.sku),
                                sku: toShippingProtectionSKU({
                                    offerId: item.quoteId,
                                    items: [
                                        {
                                            sku: item.sku,
                                            quantity: item.quantity,
                                            price: item.skuPrice
                                        }
                                    ]
                                }),
                                quantity: 1,
                                price: item.quotePrice
                            };
                        })
                    });
                case 5:
                    return _ctx.abrupt("return", {
                        success: true
                    });
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    (0,Log/* error */.vU)("Failed to remove the item from the cart");
                case 11:
                    return _ctx.abrupt("return", {
                        success: false
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function rawAddWarranty(cart) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var Cart_rawAddWarranty = (rawAddWarranty);


/***/ }),

/***/ 24332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ withWorryFreeQuote; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30901);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers_FP__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13174);
/* harmony import */ var _services_ClientSideCache__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99486);
/* harmony import */ var _data_constants_EXTEND_SKU__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51250);
/* harmony import */ var _data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49125);
/* harmony import */ var _helpers_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32054);
/* harmony import */ var _helpers_isFeatureEnabled__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(965);














var keepingRelevantSkus = function(items) {
    return items.filter(function(item) {
        return !item.sku.includes(_data_constants_EXTEND_SKU__WEBPACK_IMPORTED_MODULE_9__/* .EXTEND_SKU */ .J) && !item.sku.includes(_data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_10__/* .SHIPPED_SHIELD_SKU */ .E);
    });
};
var RequiredItemProps = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    sku: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    name: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    salePrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    quantity: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    isReturnable: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg)(),
    imageUrl: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)()
});
var requiredPropsForProtectionQuote = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .assertion */ .P5)(RequiredItemProps);
var responseShapeForQuotedItem = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    line_item_id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    product_id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    quantity: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    price: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)()
});
var QuoteAPIResponse = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    quotes: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
        quote_id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
        price: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
        status: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .literal */ .i0)("accepted"),
        line_items: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(responseShapeForQuotedItem)
    }))
});
var assertQuoteAPIResponse = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .assertion */ .P5)(QuoteAPIResponse);
var sadPath = function(cart) {
    return function(err) {
        (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("Failed to get worry-free quote: ".concat(String(err)));
        return {
            warrantyOfferId: null,
            warrantyOfferPrice: null,
            warrantyOfferItems: cart.warrantyOfferItems
        };
    };
};
var getAdjustedSalePrice = function(cartItem) {
    var salePrice = cartItem.salePrice - cartItem.couponAmount / cartItem.quantity;
    return (0,_helpers_common__WEBPACK_IMPORTED_MODULE_7__.formatPriceValue)(salePrice);
};
var currentQuotableItemsOnCart = function(cart) {
    return cart.lineItems.map(function(item) {
        return {
            sku: item.sku,
            quantity: item.quantity,
            salePrice: getAdjustedSalePrice(item)
        };
    }).filter(function(item) {
        return !item.sku.includes(_data_constants_EXTEND_SKU__WEBPACK_IMPORTED_MODULE_9__/* .EXTEND_SKU */ .J) && !item.sku.includes(_data_constants_SHIPPED_SHIELD_SKU__WEBPACK_IMPORTED_MODULE_10__/* .SHIPPED_SHIELD_SKU */ .E);
    });
};
var hashableItemToString = function(item) {
    return "".concat(item.sku, "-").concat(item.quantity, "-").concat(item.salePrice);
};
var shouldFetchNewQuote = function(cart) {
    var expectedItems = currentQuotableItemsOnCart(cart);
    return !(expectedItems.length === cart.warrantyOfferItems.length && expectedItems.every(function(item) {
        return cart.warrantyOfferItems.some(function(warrantyItem) {
            return warrantyItem.sku === item.sku && warrantyItem.quantity === item.quantity && warrantyItem.skuPrice === item.salePrice;
        });
    }));
};
var adjustQuotableItems = function(cart) {
    return cart.lineItems.map(function(lineItem) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, lineItem), {
            salePrice: getAdjustedSalePrice(lineItem)
        });
    });
};
var fetchNewQuote = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cart) {
        var data;
        return _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_3___default().post("".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_4__.SHOP_ORIGIN, "/oauth/worry-free-delivery/quote"), {
                        cartId: cart.id,
                        items: keepingRelevantSkus(adjustQuotableItems(cart)).map(requiredPropsForProtectionQuote)
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", assertQuoteAPIResponse(data));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchNewQuote(cart) {
        return _ref.apply(this, arguments);
    };
}();
// Parse quote reponse core attributes
var getQuoteItemCoreattributes = function(quoteItem) {
    return {
        sku: quoteItem.product_id,
        quantity: quoteItem.quantity,
        skuPrice: quoteItem.price
    };
};
var withWorryFreeQuoteHappyPath = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cart) {
        var quotes;
        return _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if ((0,_helpers_isFeatureEnabled__WEBPACK_IMPORTED_MODULE_8__/* .isFeatureEnabled */ .cr)("worryFreeDelivery")) {
                        _ctx.next = 2;
                        break;
                    }
                    throw new Error("WFD disabled");
                case 2:
                    if (shouldFetchNewQuote(cart)) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        warrantyOfferId: cart.warrantyOfferId,
                        warrantyOfferPrice: cart.warrantyOfferPrice,
                        warrantyOfferItems: cart.warrantyOfferItems
                    });
                case 4:
                    _ctx.next = 6;
                    return fetchNewQuote(cart);
                case 6:
                    quotes = _ctx.sent.quotes;
                    return _ctx.abrupt("return", {
                        warrantyOfferId: quotes.map(function(quote) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                quoteId: quote.quote_id
                            }, getQuoteItemCoreattributes(quote.line_items[0])), {
                                quotePrice: quote.price
                            });
                        }),
                        warrantyOfferPrice: quotes.reduce(function(acc, quote) {
                            return acc + quote.price;
                        }, 0),
                        warrantyOfferItems: quotes.map(function(quote) {
                            return getQuoteItemCoreattributes(quote.line_items[0]);
                        })
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function withWorryFreeQuoteHappyPath(cart) {
        return _ref.apply(this, arguments);
    };
}();
var sortbasedOnSku = function(a, b) {
    return a.sku.localeCompare(b.sku);
};
var hashCartItems = function(cart) {
    return keepingRelevantSkus(currentQuotableItemsOnCart(cart)).sort(sortbasedOnSku).map(hashableItemToString).join(",");
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var cacheByQuotableItems = (0,_services_ClientSideCache__WEBPACK_IMPORTED_MODULE_6__/* .ClientSideCache */ .N)("services/Cart/withWorryFreeQuote.ts:cacheByQuotableItems")(hashCartItems);
var withWorryFreeQuote = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cart) {
        return _codebuild_output_src4243868678_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_helpers_FP__WEBPACK_IMPORTED_MODULE_5__/* .thenCaught */ .HA)(withWorryFreeQuoteHappyPath)(sadPath(cart))(cart));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function withWorryFreeQuote(cart) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 6888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eR": function() { return /* binding */ BCCart; },
/* harmony export */   "i3": function() { return /* binding */ assertBCCarts; },
/* harmony export */   "lS": function() { return /* binding */ BCCartCoupon; },
/* harmony export */   "st": function() { return /* binding */ assertBCCart; }
/* harmony export */ });
/* unused harmony exports BCCurrency, assertBCCurrency, BCCartDiscounts, BCCartCustomItem, BCProductOption, BCAppliedDiscount, BCCartDigitalItem, BCContactEntity, BCGiftCertificate, BCPhysicallItem, BCCartLineItems, toNumber, BCCarts */
/* harmony import */ var _helpers_withSentryAssertion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32237);
/* harmony import */ var _recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30901);


var BCCurrency = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    name: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    code: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    symbol: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    decimalPlaces: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)()
});
var assertBCCurrency = (0,_helpers_withSentryAssertion__WEBPACK_IMPORTED_MODULE_0__/* .withSentryAssertion */ .o)([
    BCCurrency,
    "Bigcommerce Currency"
]);
var BCCartCoupon = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    code: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    couponType: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    displayName: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    discountedAmount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)()
});
var BCCartDiscounts = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    discountedAmount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)()
});
var BCCartCustomItem = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    extendedListPrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    listPrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    name: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    quantity: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    sku: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)()
});
var BCProductOption = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    name: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    nameId: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    value: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    valueId: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)()
});
var BCAppliedDiscount = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    discountedAmount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__.or)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(), (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)())
});
var BCCartDigitalItem = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    options: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(BCProductOption)),
    brand: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    couponAmount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    discountAmount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    discounts: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(BCAppliedDiscount),
    extendedListPrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    extendedSalePrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    imageUrl: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    isTaxable: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg)(),
    listPrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    originalPrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    name: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    parentId: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)())),
    productId: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__.or)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(), (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)()),
    quantity: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    salePrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    sku: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    url: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    variantId: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)()
});
var BCContactEntity = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    email: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    name: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)()
});
var BCGiftCertificate = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    amount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    isTaxable: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg)(),
    message: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    name: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    recipient: BCContactEntity,
    sender: BCContactEntity,
    theme: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)()
});
var BCPhysicallItem = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    options: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(BCProductOption)),
    brand: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    couponAmount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    discountAmount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    discounts: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(BCAppliedDiscount),
    extendedListPrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    extendedSalePrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    imageUrl: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    isTaxable: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg)(),
    listPrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    originalPrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    name: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    parentId: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__.or)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(), (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .literal */ .i0)(null)),
    productId: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    quantity: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    salePrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    sku: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    url: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    variantId: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    giftWrapping: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__.or)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .literal */ .i0)(null), (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
        amount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
        message: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
        name: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)()
    })),
    isShippingRequired: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg)(),
    comparisonPrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)()),
    extendedComparisonPrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)()),
    addedByPromotion: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg)()),
    isMutable: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg)())
});
var BCCartLineItems = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    customItems: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(BCCartCustomItem),
    digitalItems: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(BCCartDigitalItem),
    giftCertificates: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(BCGiftCertificate),
    physicalItems: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(BCPhysicallItem)
});
var toNumber = function(v) {
    return Number.isNaN(Number(v)) ? 0 : Number(v);
};
var BCCart = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    id: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    customerId: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .asType */ .fr)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .union */ .G0)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(), (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)())), toNumber),
    email: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)()),
    // currency: nullable(BCCurrency),
    // isTaxIncluded: bool(),
    baseAmount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    discountAmount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    cartAmount: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    coupons: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(BCCartCoupon),
    discounts: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(BCCartDiscounts),
    lineItems: BCCartLineItems,
    createdTime: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    updatedTime: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    locale: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)()
});
var BCCarts = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)(BCCart);
var assertBCCart = (0,_helpers_withSentryAssertion__WEBPACK_IMPORTED_MODULE_0__/* .withSentryAssertion */ .o)([
    BCCart,
    "Bigcommerce Cart"
]);
var assertBCCarts = (0,_helpers_withSentryAssertion__WEBPACK_IMPORTED_MODULE_0__/* .withSentryAssertion */ .o)([
    BCCarts,
    "Bigcommerce Carts Array"
]);


/***/ })

}]);